import { AgentStatus, ChannelType, CustomerSubscribeStatus } from '~/constants';

export const wabaEnabledInWAAgent = (agent) =>
  !!agent?.providerCapabilities?.settings?.waba_enabled &&
  agent.status === AgentStatus.ACTIVE;

export const filterSubscriptions = (customer, agents) => {
  const { subscriptions } = customer;

  const echoAgent = agents.find(
    ({ channel_type }) => channel_type === ChannelType.ECHO
  );

  if (
    echoAgent !== undefined &&
    subscriptions[echoAgent.id] === CustomerSubscribeStatus.ACTIVE
  ) {
    return [echoAgent];
  }

  return agents.filter((agent) => {
    const { id, status, channel_type } = agent;

    if (status !== AgentStatus.ACTIVE) {
      return false;
    }

    if (subscriptions[id] === CustomerSubscribeStatus.CANCELLED) {
      return false;
    }

    if ([ChannelType.SMS, ChannelType.VI].includes(channel_type)) {
      return true;
    }

    return subscriptions[id] === CustomerSubscribeStatus.ACTIVE;
  });
};

export const filterWAAgentsWithWABA = (customer, agents) => {
  const { subscriptions } = customer;

  return agents.filter((agent) => {
    const { id, status, channel_type } = agent;

    return (
      channel_type === ChannelType.WA &&
      status === AgentStatus.ACTIVE &&
      subscriptions[id] !== CustomerSubscribeStatus.CANCELLED &&
      wabaEnabledInWAAgent(agent)
    );
  });
};
